import { MUSIC_VOLUME_KEY, readVolumeSetting, SFX_VOLUME_KEY, type AudioDirector } from '../audio/audio';

/** Persist the start-screen mix without sending slider gestures to steering. */
export function bindAudioControls(audio: AudioDirector): void {
  const sliders = ['music', 'sfx'].map(name => document.getElementById(`${name}-volume`) as HTMLInputElement);
  const suppressed = new Set<string>();
  window.addEventListener('keydown', e => {
    if (suppressed.has(e.key) && !sliders.includes(e.target as HTMLInputElement)) e.stopImmediatePropagation();
  }, true);
  window.addEventListener('keyup', e => { suppressed.delete(e.key); }, true);
  for (const [index, key, fallback, set] of [
    [0, MUSIC_VOLUME_KEY, 0.5, (v: number) => audio.setMusicVolume(v)],
    [1, SFX_VOLUME_KEY, 0.9, (v: number) => audio.setSfxVolume(v)],
  ] as const) {
    const slider = sliders[index];
    const value = readVolumeSetting(key, fallback);
    slider.value = String(Math.round(value * 100));
    set(value);
    slider.addEventListener('input', () => set(Number(slider.value) / 100));
    slider.addEventListener('keydown', e => {
      if (e.key !== 'Tab') { suppressed.add(e.key); e.stopPropagation(); }
    });
    for (const event of ['pointerdown', 'pointermove', 'mousedown', 'touchstart', 'click']) {
      slider.addEventListener(event, e => e.stopPropagation());
    }
  }
}
